'use client'
import Image from 'next/image';
import { Link } from "@heroui/react";
import { timeFromNow } from '@/util/dateUtils';



interface FeaturedArticleProps {
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  imageUrl: string;
  publishedAt: Date;
}

export function FeaturedArticle({ title, category, excerpt, imageUrl, publishedAt, slug }: FeaturedArticleProps) {

  // console.log(category)
  return (
    <div className="relative isolate overflow-hidden py-24 sm:py-32 rounded-2xl">
      <Image
        src={imageUrl}
        alt=""
        className="absolute inset-0 -z-10 h-full w-full object-cover"
        width={1920}
        height={1080}
      />
      <div className="absolute inset-0 bg-black/70">
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
      </div>
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
        <Link href={`/news/${slug}`}><h3 className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-6xl [text-shadow:_2px_2px_2px_rgb(0_0_0_/_0.75)]">{title}</h3></Link>
        <Link href={`/news/${slug}`}><p className="mt-6 text-xl leading-8 text-gray-100 [text-shadow:_1px_1px_2px_rgb(0_0_0_/_1)]">
            {excerpt}
          </p></Link>
        </div>
      </div>
      <div className="absolute bottom-4 left-4 text-sm text-gray-200 z-10">
        <time dateTime={publishedAt.toISOString()}>
        {timeFromNow(publishedAt ?? new Date())}
        </time>
      </div>
      <div className="absolute bottom-4 right-4 text-sm text-gray-200 z-10">
      <p className="ml-2 text-lg font-semibold leading-8 text-white [text-shadow:_1px_1px_1px_rgb(0_0_0_/_0.75)]">
          <span className="opacity-35">/</span> {category} <span className="opacity-35">/</span>
          </p>
      </div>
    </div>
  );
}